import { withKeycloak } from "@react-keycloak/web";
import React from "react";
import ClassificationService from "../../../../../services/ClassificationService";
import ClassificationTypeService from "../../../../../services/ClassificationTypeService";
import {
  activeFilter,
  selectFilter,
  trueFilter
} from "../../../../../services/FilteringUtils";
import CommonUtil from "../../../../../utils/CommonUtil";
import { constants } from "../../../../../utils/Constants";
import SearchableTreeComponent from "../../../page/SearchableTreeComponent";
import ClassificationSelectionInput from "./ClassificationSelectionInput";

class ClassificationSelectionInputContainer extends SearchableTreeComponent {
  constructor(props) {
    super(props);

    this.classificationTypeService = new ClassificationTypeService(
      this.keycloak
    );
    this.classificationService = new ClassificationService(this.keycloak);
    this.state = {
      ...this.state,
      checkedKeys: this.initCheckedKeys(),
      checkedTree: [],
      isLoading: false,
      classificationsPageInfo: {
        filters: {
          ...activeFilter,
          fetchParents: trueFilter,
          fetchChildren: trueFilter
        }
      },
      isFirstValue: true
    };
  }

  needChangingDefaultValues = () => {
    return (
      (this.props.defaultClassifications !==
        this.state.defaultClassifications &&
        this.state.isFirstValue) ||
      this.props.reset
    );
  };

  componentDidUpdate() {
    super.componentDidUpdate();
    if (this.needChangingDefaultValues()) {
      this.setState(
        {
          defaultClassifications: this.props.defaultClassifications,
          isFirstValue: false,
          reset: this.props.reset
        },
        this.setDefaultValues
      );
      if (this.props.reset) {
        this.props.reseted();
      }
    }
  }

  setDefaultValues = () => {
    let checkedKeys;
    if (this.state.reset) {
      checkedKeys = this.initCheckedKeys();
    } else {
      const values = (this.state.defaultClassifications || []).map(item =>
        item.id.toString()
      );
      checkedKeys = this.initCheckedKeysWithDifferentPages(values);
    }
    this.setCheckedKeys(checkedKeys);
  };

  initialPageInfo() {
    var pageInfo = super.initialPageInfo();
    pageInfo.filters = {
      ...pageInfo.filters,
      classificationActive: trueFilter
    };
    return pageInfo;
  }

  initCheckedKeys() {
    return {
      checked: [],
      halfChecked: []
    };
  }

  initialPageSize() {
    if (this.props.initialPageSize) {
      return this.props.initialPageSize();
    }
    return super.initialPageSize();
  }

  loadRoots = pageInfo => {
    this.prepareCall(
      this.classificationTypeService.getEntities(
        pageInfo,
        this.sortInfo,
        this.onRootDataLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onRootDataLoad = data => {
    const pageInfo = {
      ...data.page,
      filters: this.state.pageInfo.filters
    };
    if (data._embedded) {
      const content = data._embedded.content.map(item => {
        return {
          ...item,
          key: constants.TYPE_PREFIX + item.id,
          selectable: !item.leaf,
          disabled: true
        };
      });

      this.setState({
        loadedKeys: [],
        content: content,
        links: data._links,
        pageInfo: pageInfo
      });

      this.loadFirstLevels(data._embedded.content);
    }
  };

  loadFirstLevels = roots => {
    roots.forEach(root => {
      this.prepareCall(
        this.classificationService.getClassificationsByType(
          root,
          this.onTypeDataLoad,
          this.messageHandler.handleError,
          this.state.classificationsPageInfo
        )
      );
    });
    this.performCalls();
  };

  loadDataByType = type => {
    this.prepareCall(
      this.classificationService.getClassificationsByType(
        type,
        this.onTypeDataLoad,
        this.messageHandler.handleError,
        this.state.classificationsPageInfo
      )
    );
    return this.performCalls();
  };

  onTypeDataLoad = data => {
    const treeNodeData = this.state.content.find(
      item =>
        "" + item.id ===
        CommonUtil.queryParamsGetValueForKey(
          constants.CLASSIFICATION_TYPE_ID,
          data._links.self.href
        )
    );

    this.state.loadedKeys.push(treeNodeData.key);
    if (data._embedded) {
      const children = data._embedded.content.map(item => {
        return {
          ...item,
          key: "" + item.id,
          selectable: this.props.classificationsFilter
            ? this.props.classificationsFilter.includes(item.id)
            : true,
          disabled: false
        };
      });
      treeNodeData.children = children;
    } else {
      treeNodeData.children = undefined;
      treeNodeData.leaf = true;
    }
    this.setState({
      loadedKeys: this.state.loadedKeys,
      content: [...this.state.content]
    });
  };

  loadDataByParent = parent => {
    this.prepareCall(
      this.classificationService.getClassificationsChildren(
        parent,
        this.onDataLoad,
        this.messageHandler.handleError,
        this.state.classificationsPageInfo
      )
    );
    return this.performCalls();
  };

  loadData = (expanded, onLoadCallback) => {
    if (expanded.disabled) {
      return this.loadDataByType(expanded);
    } else {
      return this.loadDataByParent(expanded, onLoadCallback);
    }
  };

  checkNodeCallback = (item, data) => {
    return (
      !item.key.startsWith(constants.TYPE_PREFIX) &&
      "" + item.id ===
        CommonUtil.queryParamsGetValueForKey(
          constants.CLASSIFICATION_PARENT_ID,
          data._links.self.href
        )
    );
  };

  loadEntitiesWithFilter = pageInfo => {
    this.loadClassificationsWithFilter(pageInfo);
  };

  loadClassificationsWithFilter = pageInfo => {
    this.prepareCall(
      this.classificationService.getEntities(
        pageInfo,
        this.sortInfo,
        this.onLoadWithFilter,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onLoadWithFilter = data => {
    const pageInfo = data.page;
    pageInfo.filters = this.state.pageInfo.filters;
    let content = [];
    const dataContent = CommonUtil.getDataContent(data);
    if (dataContent) {
      content = dataContent.map(item => {
        return {
          ...item,
          key: "" + item.id,
          selectable: this.props.classificationsFilter
            ? this.props.classificationsFilter.includes(item.id)
            : true,
          leaf: true
        };
      });
    }
    this.setState(
      {
        loadedKeys: [],
        content: content,
        links: data._links,
        pageInfo: pageInfo
      },
      () => this.setCheckedKeys(this.state.checkedKeys)
    );
  };

  findParentsListInTree = nodeKey => {
    let keys = [];

    const parent = this.findParentOfNode(this.state.content, nodeKey);
    if (parent) {
      keys.push(parent.key);
      keys = keys.concat(this.findParentsListInTree(parent.key));
    }
    return keys;
  };

  checkKeyExistsWithAllChildren = (key, currentCheckedTree) => {
    const node = this.findInTreeByKey(currentCheckedTree, key);
    if (!node) return false;
    if (node.children) {
      if (node.children.length !== node.numberOfChildren) {
        return false;
      } else {
        return node.children.every(childKey =>
          this.checkKeyExistsWithAllChildren(childKey, currentCheckedTree)
        );
      }
    } else {
      return true;
    }
  };

  initCheckedKeysWithDifferentPages = eventCheckedKeys => {
    let { checked } = this.state.checkedKeys;
    let currentCheckedTree = this.state.checkedTree;
    if (this.state.searchValue && this.state.searchValue !== "") {
      const includes = eventCheckedKeys.filter(
        key =>
          !this.findInTreeByKey(currentCheckedTree, key) ||
          !checked.includes(key)
      );

      const excludes = checked
        .filter(key => this.findInTreeByKey(this.state.content, key))
        .filter(key => !eventCheckedKeys.includes(key));

      excludes.forEach(key =>
        this.loop(currentCheckedTree, key, (item, index, arr) =>
          arr.splice(index, 1)
        )
      );

      eventCheckedKeys = eventCheckedKeys
        .filter(key =>
          this.checkKeyExistsWithAllChildren(key, currentCheckedTree)
        )
        .concat(includes);
      checked = checked
        .filter(key =>
          this.checkKeyExistsWithAllChildren(key, currentCheckedTree)
        )
        .concat(eventCheckedKeys);
    } else {
      currentCheckedTree = currentCheckedTree.filter(node =>
        this.findInTreeByKey(this.state.content, node.key)
      );
      checked = checked
        .filter(key => !this.findInTreeByKey(currentCheckedTree, key))
        .concat(eventCheckedKeys);
    }

    checked = checked.filter(key => !key.startsWith(constants.TYPE_PREFIX));

    return { checked, halfChecked: [] };
  };

  setCheckedKeys = checkedKeys => {
    const pageInfo = {
      filters: {
        ...activeFilter,
        classificationActive: trueFilter
      }
    };
    this.prepareCall(
      this.classificationTypeService.getEntities(
        this.addPredefinedIdsFilter(
          pageInfo,
          checkedKeys.checked,
          "classificationId"
        ),
        undefined,
        data => this.onLoadClassificationTypesOfChecked(data, checkedKeys),
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onLoadClassificationTypesOfChecked = (data, checkedKeys) => {
    const dataContent = CommonUtil.getDataContent(data);
    if (dataContent) {
      checkedKeys.halfChecked = dataContent.map(
        item => constants.TYPE_PREFIX + item.id
      );
    }
    this.prepareCall(
      this.classificationService.getEntities(
        this.addPredefinedIdsFilter(
          this.state.classificationsPageInfo,
          checkedKeys.checked
        ),
        undefined,
        data => this.onLoadClassificationsOfChecked(data, checkedKeys),
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  constructTreeFromFlat = (flatTree, targetNode) => {
    if (!flatTree) return false;
    const moved = flatTree.some(node => {
      if (node.key === targetNode.key) {
        node.children = targetNode.children;
        node.numberOfChildren = targetNode.numberOfChildren;
        return true;
      }
      return this.constructTreeFromFlat(node.children, targetNode);
    });
    return moved;
  };

  transformCheckedTree = checkedTree => {
    const nodesToDelete = [];
    checkedTree.forEach(targetNode =>
      checkedTree.some(otherNode => {
        if (otherNode.key !== targetNode.key) {
          const moved = this.constructTreeFromFlat(
            otherNode.children,
            targetNode
          );
          if (moved) {
            nodesToDelete.push(targetNode);
          }
          return moved;
        }
        return false;
      })
    );
    checkedTree = checkedTree.filter(node => !nodesToDelete.includes(node));
    return checkedTree;
  };

  onLoadClassificationsOfChecked = (data, checkedKeys) => {
    let checkedTree = [];
    const dataContent = CommonUtil.getDataContent(data);
    if (dataContent) {
      let checkedParents = checkedKeys.checked;
      while (checkedParents && checkedParents.length) {
        checkedParents = dataContent
          .filter(item => item.childrenIds)
          .filter(item => !checkedKeys.checked.includes(item.id.toString()))
          .filter(item =>
            item.childrenIds.every(childId =>
              checkedKeys.checked.includes(childId.toString())
            )
          )
          .map(item => item.id.toString());
        checkedKeys.checked = checkedKeys.checked.concat(checkedParents);
      }
      let checkedChildren = checkedKeys.checked;
      while (checkedChildren && checkedChildren.length) {
        checkedChildren = dataContent
          .filter(item => item.childrenIds)
          .filter(item => checkedKeys.checked.includes(item.id.toString()))
          .flatMap(item => item.childrenIds)
          .map(id => id.toString())
          .filter(key => !checkedKeys.checked.includes(key));
        checkedKeys.checked = checkedKeys.checked.concat(checkedChildren);
      }
      checkedKeys.halfChecked = checkedKeys.halfChecked.concat(
        dataContent
          .map(item => item.id.toString())
          .filter(id => !checkedKeys.checked.includes(id))
      );

      let oldCheckedTree;
      while (JSON.stringify(oldCheckedTree) !== JSON.stringify(checkedTree)) {
        oldCheckedTree = CommonUtil.jsonCopy(checkedTree);
        if (checkedTree.length) {
          checkedTree = this.transformCheckedTree(checkedTree);
        } else {
          checkedTree = dataContent.map(item => {
            return {
              key: item.id.toString(),
              numberOfChildren: item.childrenIds ? item.childrenIds.length : 0,
              children: item.childrenIds
                ? item.childrenIds.map(id => {
                    return {
                      key: id.toString()
                    };
                  })
                : undefined
            };
          });
        }
      }
    }
    checkedKeys.checked = checkedKeys.checked.filter(
      (item, pos) => checkedKeys.checked.indexOf(item) === pos
    );
    checkedKeys.halfChecked = checkedKeys.halfChecked.filter(
      (item, pos) => checkedKeys.halfChecked.indexOf(item) === pos
    );
    this.setState(
      { checkedKeys, checkedTree, isFirstValue: false },
      this.setCheckedClassifications
    );
  };

  createTableIdFilters = (entities, comparator) => {
    let ids = entities;
    if (ids.length === 0) {
      ids = [-1];
    }
    return selectFilter(ids, comparator);
  };

  addPredefinedIdsFilter(
    pageInfo,
    predefined,
    filterName = "id",
    comparator = "IN"
  ) {
    pageInfo = {
      ...pageInfo,
      filters: {
        ...pageInfo.filters,
        [filterName]: this.createTableIdFilters(predefined, comparator)
      }
    };
    return pageInfo;
  }

  onCheck = (eventCheckedKeys, event) => {
    if (event.node && event.node.key) {
      const checkedKeys = this.initCheckedKeysWithDifferentPages(
        eventCheckedKeys
      );
      this.setCheckedKeys(checkedKeys);
    }
  };

  isNodeFromType = (node, key) => {
    if (node.key === key) {
      return true;
    }
    return this.findInTreeByKey(node.children, key);
  };

  setCheckedClassifications = () => {
    this.props.setSelectedClassifications(this.state.checkedKeys.checked);
  };

  removeDisabledParentsFromTree = tree => {
    let children = [];
    if (tree && tree.length > 0) {
      tree.forEach(element => {
        if (!element.disabled) {
          children.push(element);
        }
        if (element.children && element.children.length > 0) {
          children = children.concat(element.children);
        }
      });
    }
    return children;
  };

  render() {
    return (
      <ClassificationSelectionInput
        {...this.renderProps()}
        checkedKeys={this.state.checkedKeys}
        onCheck={this.onCheck}
      />
    );
  }
}

export default withKeycloak(ClassificationSelectionInputContainer);
